<template>
  <v-container class="disclaimer-container">
    <!-- Header Section -->
    <v-row class="header-row">
      <v-col>
        <h1 class="header-title">For Enquiries & Appointment</h1>
        <v-row class="header-content">
          <a class="contact-button" href="https://api.whatsapp.com/send/?phone=6587602584&text&app_absent=1" target="_blank">8760 2584</a>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <h1 class="header-title">A Premium Development By</h1>
        <v-row class="header-content">
          <v-img src="@/assets/dev_logo.png" alt="Developer Logo" height="50px" contain></v-img>
        </v-row>
      </v-col>
    </v-row>

    <!-- Notice and Disclaimer Section -->
    <v-row class="content-row">
      <v-col cols="12">
        <p class="disclaimer">
          <strong>Disclaimer: </strong>
          <span>
            While every reasonable care has been taken in preparing this website and in constructing the models and showflats, the developer and the marketing agent cannot be held responsible for any inaccuracies or omissions. Visual representations, models, showflat displays and illustrations, photographs, art renderings and other graphic representations and references are intended to portray only artistic impressions of the development and cannot be regarded as representation of fact. Floor areas are approximate measurements and subject to final survey. The property is subject to inspection by the relevant authorities to comply with the current codes of practice. All information, specifications, renderings, visual representations and plans are current at the time of publication and are subject to change as may be required by us and/or the competent authorities and shall not be regarded as statements or representations of facts. All plans are subject to amendments as directed and/or approved by the building authorities. All areas are approximate measurements only and subject to final survey. The Sales and Purchase Agreement shall form the entire agreement between us, the Developer and the Purchaser and shall supersede all statements, representations or promises made prior to the signing of the Sale and Purchase Agreement and shall in no way be modified by any statements, representations or promises made by us or the Marketing Agent.
          </span>
        </p>
      </v-col>
    </v-row>

    <!-- Footer Section -->
    <v-row class="footer-row">
      <v-col cols="12" class="footer-content">
        <div class="footer-buttons">
          <button class="footer-button">Terms of Use</button>
          <button class="footer-button">Privacy Policy</button>
          <button class="footer-button">Cookie Policy</button>
        </div>
        <v-spacer></v-spacer>
        <p class="copyright">Copyright 2025 | All Rights Reserved</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'EnquiriesPage',
};
</script>

<style scoped>
.disclaimer-container {
  max-width: 800px; /* Reduced container width */
  margin: 0 auto;
  padding: 20px; /* Adjusted padding */
  width: 100%; /* Ensure it takes full width on smaller screens */
}

.header-row {
  margin-bottom: 20px; /* Adjusted margin */
  display: flex;
  flex-wrap: wrap; /* Allow wrapping on smaller screens */
  gap: 20px; /* Space between columns */
  align-items: center;
}

.header-title {
  font-size: 1rem; /* Adjusted font size */
  text-transform: uppercase;
  font-weight: bold;
  color: #2c3e50; /* Dark text color */
  margin-bottom: 10px; /* Space between title and button */
  text-align: center;
}


.contact-button {
  font-size: 1rem;
  border-radius: 8px;
  padding: 2px 20px;
  border: 2px solid #3A2B22; /* Add a solid border */
  text-decoration: none; /* Remove underline */
  display: inline-block; /* Ensure padding works */
  transition: background-color 0.3s ease;
  font-weight: bold; /* Make the text bold */
  color: #3A2B22; /* Text color */
}


.header-content {
  display: flex;
  margin: 10px; /* Space between test items */
  justify-content: center; /* Center test items */
}

.header-content h1 {
  font-size: 1.2rem;
  color: #666; /* Subdued text color */
  margin: 0;
}

.content-row {
  margin-bottom: 20px; /* Adjusted margin */
}

.disclaimer {
  font-size: 0.9rem; /* Adjusted font size */
  line-height: 1.6; /* Improved line height */
  text-align: justify;
  color: #666;
}

.footer-row {
  border-top: 1px solid #e0e0e0;
  padding-top: 20px; /* Adjusted padding */
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; /* Allow wrapping on smaller screens */
  gap: 10px; /* Space between buttons and copyright */
}

.footer-buttons {
  display: flex;
  gap: 10px; /* Adjusted gap */
  flex-wrap: wrap; /* Allow buttons to wrap on smaller screens */
}

.footer-button {
  padding: 8px 16px; /* Adjusted padding */
  font-size: 0.9rem; /* Adjusted font size */
  color: #2c3e50;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 8px; /* Rounded corners */
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.footer-button:hover {
  background-color: #e0e0e0; /* Hover effect */
}

.copyright {
  font-size: 0.9rem; /* Adjusted font size */
  color: #666;
  margin: 0;
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  .header-row {
    flex-direction: column; /* Stack columns vertically on mobile */
    align-items: center;
    text-align: center;
  }

  .test-row {
    justify-content: center; /* Center test items on mobile */
  }

  .footer-content {
    flex-direction: column; /* Stack footer content vertically on mobile */
    align-items: center;
  }

  .footer-buttons {
    justify-content: center; /* Center buttons on mobile */
  }

  .contact-button {
    width: 100%; /* Full-width button on mobile */
    text-align: center;
  }
}
</style>